import { useEffect, useRef, useState } from "react";
import TagManager from "react-gtm-module";
import { Link, NavLink } from "react-router-dom";
import styles from "./Header.module.css";

const navigation = [
  ["/שירותים-ירוקים", "פתרונות"], ["/השוואת-משתנות-ללא-מים", "השוואת משתנות"],
  ["/articles", "מאמרים"], ["/about", "אודות"], ["/contact", "צור קשר"],
];
const phoneClick = () => TagManager.dataLayer({ dataLayer: { event: "phone_call", pageTitle: document.title } });

function Header() {
  const drawerRef = useRef(null);
  const toggleRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    const drawer = drawerRef.current;
    const show = () => setExpanded(true);
    const hide = () => { setExpanded(false); toggleRef.current?.focus(); };
    drawer.addEventListener("show.bs.offcanvas", show);
    drawer.addEventListener("hidden.bs.offcanvas", hide);
    return () => {
      drawer.removeEventListener("show.bs.offcanvas", show);
      drawer.removeEventListener("hidden.bs.offcanvas", hide);
    };
  }, []);
  return (
    <>
      <div className={styles.contactHeader} dir="rtl">
        <div className={styles.utilityInner}>
          <a href="tel:0544494384" dir="ltr" onClick={phoneClick}>0544494384</a>
          <a href="mailto:waterless.israel@gmail.com" dir="ltr">waterless.israel@gmail.com</a>
        </div>
      </div>
      <nav className={`navbar navbar-expand-xl navbar-light ${styles.navbar}`} aria-label="תפריט ניווט ראשי" dir="rtl">
        <div className={styles.navInner}>
          <Link className={styles.brand} to="/"><img src="/assets/images/waterlessLogo.png" alt="ווטרלס - משתנות ללא מים" loading="lazy" /></Link>
          <button ref={toggleRef} className={`navbar-toggler ${styles.navbarToggler}`} type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" aria-label="פתח תפריט" aria-expanded={expanded}>
            <span className="navbar-toggler-icon" aria-hidden="true" />
          </button>
          <div ref={drawerRef} className={`offcanvas offcanvas-end ${styles.drawer}`} tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
            <div className="offcanvas-header">
              <h2 id="offcanvasRightLabel" className={styles.drawerTitle}>תפריט ניווט</h2>
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="סגור תפריט" />
            </div>
            <div className={`offcanvas-body ${styles.drawerBody}`}>
              {/* Delegate dismissal so Bootstrap does not cancel router navigation. */}
              <ul className={`navbar-nav ${styles.navigation}`} data-bs-dismiss="offcanvas">
                {navigation.map(([to, label]) => <li className="nav-item" key={to}><NavLink className={`nav-link ${styles.navLink}`} to={to}>{label}</NavLink></li>)}
                <li className="nav-item"><Link className={styles.quoteBtn} to="/contact">בקשת הצעת מחיר</Link></li>
              </ul>
              <div className={styles.drawerContact} data-bs-dismiss="offcanvas">
                <a href="tel:0544494384" dir="ltr" onClick={phoneClick}>0544494384</a>
                <a href="mailto:waterless.israel@gmail.com" dir="ltr">waterless.israel@gmail.com</a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
export default Header;
